import React from "react";
import { FormPatternTypes } from "./type";
import copy from "copy-to-clipboard";
import { message } from "antd";
import cls from "classnames";

export function connect(target, config, ...args) {
    let Target = args.reduce((target, mapper) => {
        return mapper(target, config);
    }, target);
    if (!React.isValidElement(Target)) {
        return React.createElement(Target);
    }
    return Target;
}

export function mapReadPretty({ component, componentProps = {} }) {
    return (target, config) => {
        if (config.pattern === FormPatternTypes.readPretty) {
            return React.createElement(component, { ...componentProps });
        }
        return target;
    };
}

export function mapCopy(onClick) {
    return (target, config) => {
        if (config.copyTag) {
            return props => {
                return (
                    <div className={"copy-item"}>
                        <div
                            className={cls({
                                ["copy-content"]: true,
                                ["copy-content-read-pretty"]: config.pattern === FormPatternTypes.readPretty,
                            })}>
                            {React.cloneElement(target, { ...props })}
                        </div>
                        <label
                            className={cls({
                                ["copy-icon"]: true,
                                ["copy-icon-read-pretty"]: config.pattern === FormPatternTypes.readPretty,
                            })}
                            title={"复制"}
                            onClick={() => {
                                const value = onClick();
                                copy(value);
                                message.success("复制成功");
                            }}>
                            &#xeb4e;
                        </label>
                    </div>
                );
            };
        }
        return target;
    };
}
